<template>
    <div class="m_pad max-w-screen-xl mx-auto" role="main">
        <h1 class="mx-auto py-4 text-left text-4xl font-bold">{{ $t('Home.LandingPage.Heading') }}</h1>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="file-a-fictitious-business-name-button"
                :aria-label="$t(`Home.LandingPage.FileFBNButton`) + ' ' + $t(`Home.LandingPage.FileFBNButtonDescription`)"
                @click="FilingSelection(LandingPageFilingSelection.FileFictitiousBusinessName)">
                <p class="button-header">{{ $t(`Home.LandingPage.FileFBNButton`) }}</p>
                <p class="button-info">{{ $t(`Home.LandingPage.FileFBNButtonDescription`) }}</p>
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="provide-proof-of-publication-button"
                :aria-label="$t(`Home.LandingPage.ProofOfPublicationButton`)"
                @click="FilingSelection(LandingPageFilingSelection.ProofOfPublication)">
                <p class="button-header">{{ $t(`Home.LandingPage.ProofOfPublicationButton`) }}</p>
            </button>
        </div>
        <div class="text-center py-2">
            <button
                class="max-w-100 text-white text-center rounded darkblue px-6 py-4 font-semibold shadow-lg focus:outline-none cursor-pointer"
                id="online-copy-number-lookup-button"
                :aria-label="$t(`Home.LandingPage.CertifiedCopyVerificationButton`)"
                @click="FilingSelection(LandingPageFilingSelection.OnlineCopyNumberLookup)">
                <p class="button-header">{{ $t(`Home.LandingPage.CertifiedCopyVerificationButton`) }}</p>
            </button>
        </div>       
        <div class="py-1">
            <p class="py-3 text-left text-2xl font-bold" id="small-business-info">{{ $t('Home.LandingPage.Copy1.Heading1') }}</p>
            <p class="py-1 text-left text-xl" v-html="$t('Home.LandingPage.Copy1.Line1')"></p>
        </div>
        <div class="py-1">
            <p class="py-3 text-left text-2xl font-bold" id="who-should-file">{{ $t('Home.LandingPage.Copy2.Heading1') }}</p>
            <p class="py-1 text-left text-xl">{{ $t('Home.LandingPage.Copy2.Line1') }}</p>
            <p class="py-1 text-left text-xl">{{ $t('Home.LandingPage.Copy2.Line2') }}</p>
            <p class="py-1 text-left text-xl">{{ $t('Home.LandingPage.Copy2.Line3') }}</p>
            <p class="py-1 text-left text-xl link-color hover:text-indigo-500"><a href="https://www.lavote.gov/home/county-clerk/fictitious-business-names/filing/requirements" target="_blank">{{ $t('Home.LandingPage.Copy2.Line4') }}</a></p>
        </div>
    </div>
</template>

<script>
import { LandingPageFilingSelection } from '../../assets/constants.js'
export default {
    name: 'LandingPage',
    data: () => ({
        fbnFiling: {},
        LandingPageFilingSelection: LandingPageFilingSelection
    }),
    methods: {
        FilingSelection (selection) {
            if (selection === LandingPageFilingSelection.FileFictitiousBusinessName) {
                this.$router.push('fbnfilingapproach')
            } else {
                if (selection === LandingPageFilingSelection.ProofOfPublication) {
                    this.fbnFiling.isProofOfPublication = true
                    this.fbnFiling.workflow = selection
                } else {
                    this.fbnFiling.isOnlineCopyNumberLookup = true
                }
                this.$store.dispatch('setFbnFiling', this.fbnFiling)
                this.$store.dispatch('setWorkflow', selection)
                this.$router.push('fbnlookup')
            }
            this.$store.dispatch('setAppHasData', true)
        },
        initializeFbnFiling () {
            this.fbnFiling = { 
                // Variables
                approach: '',
                inProgress: false,
                fbnFilingActions: [],
                reviewPageEdit: false,
                workflow: '',
                isProofOfPublication: false,
                isOnlineCopyNumberLookup: false,
                // Page Objects
                RegisteredOwnerPage: {
                    businessType: '',
                    filingActions: [],
                    registeredOwners: [],
                    registeredOwnerTempId: 0,
                    sosFile: []
                },
                BusinessNamePage: {
                    fbnNames: [],
                    originalFbnNames: [],
                    filingActions: [],
                    businessNameId: {}
                },
                BusinessAddressPage: {
                    filingActions: [],
                    internationalBusiness: false,
                    BusinessAddress: {
                        address: '',
                        additionalAddress: '',
                        city: '',
                        state: '',
                        zipCode: '',
                        county: '',
                        country: 'United States',
                        articles: ''
                    },
                    OriginalBusinessAddress: {
                        address: '',
                        additionalAddress: '',
                        city: '',
                        state: '',
                        zipCode: '',
                        county: '',
                        country: 'United States',
                        articles: '',
                    },                 
                },
                RequestorInformationPage: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    address: '',
                    addAddress: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    country: '',
                    email: '',
                    phone: '',
                    dateRegistrantCommenced: '',
                    additionalCopies: 1
                },
                OriginalRequestorInformation: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    address: '',
                    addAddress: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    country: '',
                    email: '',
                    phone: '',
                    dateRegistrantCommenced: '',
                    additionalCopies: 1
                },
                VitalChekPage: {
                    filingActions: []
                }
            }
            this.$store.dispatch('setFbnFiling', this.fbnFiling)
        }
    },
    mounted () {
        this.$store.dispatch('clearAllState')
        this.initializeFbnFiling()
        window.scrollTo(0,0)
    }
};

</script>

<style scoped>

    .max-w-100 {
        width: 100%;
    }

    p {
        line-height: 1.65em !important;
    }

</style>
